import React, { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Img } from 'react-image';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface Props {
    title: string;
    description?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            alignItems: 'center'
        },
        image: {
            [theme.breakpoints.down('lg')]: {
                width: '486px',
                height: '242px'
            },
            [theme.breakpoints.up('xl')]: {
                width: '648px',
                height: '322px'
            }
        },
        title: {
            textAlign: 'center',
            fontWeight: 600,
            fontSize: '23px',
            [theme.breakpoints.down('lg')]: {
                marginTop: '13px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '20px',
                lineHeight: '36px'
            }
        },
        description: {
            textAlign: 'center',
            fontWeight: 500,
            [theme.breakpoints.down('lg')]: {
                marginTop: '11px',
                lineHeight: '20px',
                fontSize: '16px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '15px',
                lineHeight: '27px',
                fontSize: '18px'
            }
        },
        button: {
            [theme.breakpoints.down('lg')]: {
                marginTop: '26px',
                marginBottom: '26px',
                width: '150px',
                height: '41px',
                fontSize: '14px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '34px',
                marginBottom: '34px',
                width: '200px',
                height: '55px',
                fontSize: '18px'
            }
        }
    })
);

export const ResultsNotFound: FunctionComponent<Props> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Img
                className={classes.image}
                src="/images/clients/notFoundClients.svg"
            />
            <Typography className={classes.title}>{props.title}</Typography>
            <Typography className={classes.description}>{props.description}</Typography>
        </Box>
    );
};

export default ResultsNotFound;
